import Types, {HEADER_TABS} from '../../action/types';

/**
 * Created by Tiger on 04/03/2022.
 */

const defaultState = {
    currentTabKey: window.location?.pathname?.includes('privatisation') ? HEADER_TABS.privatisation : HEADER_TABS.main,
};

export default function onAction(state = defaultState, action) {
    switch (action.type) {
        case Types.CHANGED_HEADER_TAB:
            return {
                ...state, ...action,
            };
        default:
            return { ...state };
    }
}
